import React from 'react';

import Stack from '@mui/material/Stack';

import GuideInfoBox from '../components/GuideInfoBox';
import GuideLink from '../components/GuideLink';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';
import GuideTable from '../components/GuideTable';

const GuideTrainingOverview: React.FC = () => {
  return (
    <GuidePageLayout
      title="ワークスペース（コードエディタ）概要"
      description="VSCode ベースのコードエディタでワークスペースのファイルを編集・実行し、実行履歴の参照やリバートを行います。"
    >
      <GuideSection title="アクセス権限">
        <GuideTable
          headers={['機能', 'アクセス可能なロール']}
          rows={[
            ['マイワークスペース（自分のワークスペース）', '全ロール（権限制御なし）'],
            ['他ユーザーのワークスペース閲覧・操作', '管理者 (ADMIN) / 開発者 (DEVELOPER) のみ'],
          ]}
        />
        <Stack spacing={1} sx={{ mt: 2 }}>
          <GuideInfoBox>
            ホームの「ワークスペース」カードから利用できます（全ユーザー）。他ユーザーのワークスペースの閲覧・操作は
            ADMIN / DEVELOPER のみ可能です。
          </GuideInfoBox>
        </Stack>
      </GuideSection>

      <GuideSection title="画面構成">
        <GuideTable
          headers={['エリア', '内容']}
          rows={[
            [
              'アクティビティバー（最左）',
              'エクスプローラー / 実行履歴 の切替。選択中アイコン再クリックでサイドバーを開閉。',
            ],
            ['左ペイン（サイドバー）', 'エクスプローラー（ツリー）または実行履歴を表示。'],
            [
              '右ペイン（メインエリア）',
              '上部にタブ、その下にエディタ。保存/実行ボタンは右下にフローティング表示。',
            ],
          ]}
        />
      </GuideSection>

      <GuideSection title="作成可能なファイル">
        <GuideTable
          headers={['拡張子', '言語', '実行可否']}
          rows={[
            ['.java', 'Java', '実行可能'],
            ['.md', 'Markdown', '実行不可（編集・プレビューのみ）'],
          ]}
        />
      </GuideSection>

      <GuideSection title="関連ガイド">
        <Stack spacing={0.5}>
          <GuideLink to="training/workspace">ワークスペースを操作する</GuideLink>
          <GuideLink to="training/execute">コードを実行して履歴を確認する</GuideLink>
          <GuideLink to="training/admin">他ユーザーのワークスペースを閲覧する（管理者）</GuideLink>
        </Stack>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideTrainingOverview;
